import Box from '@mui/material/Box';
import NavLink from './NavLink';
import { useMediaQuery } from 'react-responsive';

const Navigation = () => {
    const isTinyWidth = useMediaQuery({ query: '(max-width: 470px)' });
    const tinyLinkSx = isTinyWidth ? { fontSize: '10px', pl: .55, pr: .55, letterSpacing: '.02em' } : {};
    const navLinkSx = { borderRight: '1px solid gray', ...tinyLinkSx };
    const navLinkNoBorderSx = { ...tinyLinkSx };

    return (
        <Box>
            <NavLink to="/" sx={navLinkSx} style={activeStyle}>HOME</NavLink>
            <NavLink to="/services" sx={navLinkSx} style={activeStyle}>SERVICES</NavLink>
            <NavLink to="/careers" sx={navLinkSx} style={activeStyle}>CAREERS</NavLink>
            <NavLink to="/contact" sx={navLinkNoBorderSx} style={activeStyle}>CONTACT</NavLink>
        </Box>
    );
}

const activeStyle = ({ isActive }: any) => ({ color: isActive ? 'white' : undefined });

export default Navigation;
